import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

export interface FeaturedConfig {
  _id?: string
  key: string
  featuredHotelIds: string[]
  featuredTourIds: string[]
}

export const getFeaturedConfig = async (): Promise<{ data: FeaturedConfig }> => {
  const response = await axios.get(`${API_URL}/featured/config`)
  return response.data
}

export const updateFeaturedConfig = async (body: {
  featuredHotelIds?: string[]
  featuredTourIds?: string[]
}): Promise<{ data: FeaturedConfig }> => {
  const response = await axios.patch(`${API_URL}/featured/config`, body)
  return response.data
}

export interface HotelListItem {
  _id: string
  translations?: Array<{ language: string; name?: string }>
  seoSlug?: string
}

export interface TourListItem {
  _id: string
  translations?: Array<{ language: string; title?: string }>
  seoSlug?: string
}

export const getHotelsListForFeatured = async (): Promise<HotelListItem[]> => {
  const response = await axios.get(`${API_URL}/hotels`, {
    params: { page: 0, size: 500 },
  })
  const data = response.data?.data ?? response.data
  return Array.isArray(data) ? data : []
}

export const getToursListForFeatured = async (): Promise<TourListItem[]> => {
  const response = await axios.get(`${API_URL}/tours`, {
    params: { page: 0, size: 500 },
  })
  const data = response.data?.data ?? response.data
  return Array.isArray(data) ? data : []
}
